export const CSS_PREFIX = 'ftbl__';
export const TAB_ITEM_CLASS_PREFIX = 'tab-item--';
export const ACTIVE_TAB_CLASS_PREFIX = 'active-tab--';
export const TAB_SWITCH_CONTENT_ID = 'tabs-switch__content';
export const TABS_MENU_CLASSNAME = 'tabs-menu';

export const LOCAL_NAV_EL_SELECTOR = '.j-local-nav';
export const SECTION_NAV_EL_SELECTOR = '.j-section-nav';
export const HERO_SLIM_IS_VISIBLE = 'isVisible';
export const HERO_SLIM_HOOK = '.j-hero-lmp-slim';
export const HERO_HOOK = '.j-intro';
